import axiosClient from "utils/api";
const URI = "/admin/color";

export const getColor = async (payload) => {
  const URL = `${URI}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Color:", error);
    throw error;
  }
};
export const addColor = async (payload) => {
  const URL = `${URI}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add Color:", error);
    throw error;
  }
};

export const deleteColor = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Color:", error);
    throw error;
  }
};

export const updateColor = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Edit Color:", error);
    throw error;
  }
};
